import { useState } from 'react';

import ChatBox from '../whatsapp/ChatBox';
export default function WhatsappchatPage() {
	
	const [pageReady, setPageReady] = useState(true);
	 const businessPhoneNumberId = process.env.REACT_APP_WHATSAPP_BUSINESS_PHONE_NUMBER_ID;
 const accessToken = process.env.REACT_APP_WHATSAPP_ACCESS_TOKEN;
	return (
		<main id="WhatsappchatPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="sm:col-12 comp-grid" >
                <div className="">
                    <div className="App" style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        minHeight: '100vh',
                        background: '#f0f2f5',
                        padding: '20px'
                        }}>
                        <ChatBox 
                        businessPhoneNumberId={businessPhoneNumberId}
                        accessToken={accessToken}
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
